<script>
  export let nav;
</script>

<a href={nav.link} class="border-transparent text-white hover:border-warm-300 hover:text-warm-100 border-b-2 text-xs font-medium">
  <slot></slot>
</a>